import { TFunction } from "i18next"
import { match } from "ts-pattern"
import { zkEinheit } from "../../../../../@client/Theasoft_DataClasses_Perso"

export function localizeUnit(tzEinheit: zkEinheit, t: TFunction<"app_server">) {
  return match(tzEinheit)
    .with("Tage", () => t("Days"))
    .with("Stunden", () => t("Hours"))
    .otherwise(() => null)
}
